<template>
  <div class="layout-breadcrumb">
    <div :key="key" v-for="(routeRecord, key) in routeRecords">
      <span class="slash" v-if="isShowSlash(key, routeRecord)"> / </span>
      <span class="name" :class="{ red: key === routeRecords.length - 1 }" @click="go(routeRecord)">
        {{ routeRecord.meta.breadcrumb && routeRecord.meta.breadcrumb.name }}
      </span>
    </div>
    <span v-if="isShowGoBack" class="go-back" @click="goBackPrePage"><i class="iconfont icon-back" />返回</span>
  </div>
</template>

<script>
import { USER_CENTER_URL } from "@/utils/constants/constants.menu";

export default {
  name: "LayoutBreadcrumb",
  computed: {
    routeRecords() {
      return this.$store.getters["layout/routeRecords"];
    },
    // 路由记录长度
    routeRecordsLen() {
      return this.routeRecords.length || 0;
    },
    // 当前路由
    currenRoute() {
      return this.routeRecords[this.routeRecordsLen - 1];
    },
    // 是否展示返回按钮
    isShowGoBack() {
      return this.currenRoute.meta.breadcrumb && this.currenRoute.meta.breadcrumb.isShowBack;
    },
  },
  methods: {
    go(routeRecord) {
      /** router配置为点击失效的（不存在页面的路由），则不跳 **/
      if (routeRecord && routeRecord.meta && routeRecord.meta.breadcrumb && routeRecord.meta.breadcrumb.disabled)
        return;
      /** 当前路由 不跳 **/
      const current_path = this.$route.path;
      if (current_path === routeRecord.path) return;
      this.$router
        .push({
          path: routeRecord.path,
        })
        .catch((e) => e);
    },
    /** 是否展示分割线 */
    isShowSlash(index, data) {
      return index !== 0 && data.meta.breadcrumb && data.meta.breadcrumb.name;
    },
    /** 返回 */
    goBackPrePage() {
      let url = USER_CENTER_URL;
      if (this.routeRecordsLen > 1) {
        url = this.routeRecords[this.routeRecordsLen - 2].path || USER_CENTER_URL;
      }
      this.$router.replace(url);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/config.scss";

.layout-breadcrumb {
  margin: 12px 0;
  display: flex;

  .name {
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }

  .red {
    color: $theme-color;
  }

  .slash {
    padding: 0 8px;
    font-size: 12px;
    color: #dddddd;
  }
}

.go-back {
  margin-left: 30px;
  cursor: pointer;

  i {
    margin-right: 3px;
  }

  &:hover {
    color: $theme-color;
  }
}
</style>
